module.exports = __webpack_public_path__ + "static/media/bdplogo.080396d3.png";